import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get } from 'lodash';
import messages from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/messages';
import { translate } from 'containers/services/translate';
import { Listings } from 'containers/AppContainer/typings';
import { LISTINGS } from 'containers/data-structure';
import { ExpertiseFormWrapper } from 'containers/LawyerLegalProceedingsPage/judgementAdd/JudgementAddPronouncing/styled-components';
import { Vehicule } from 'containers/PreOpeningPage/typings';
import { ExpertiseState } from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/typings';
import SahamAccordion from 'components/SahamAccordion';
import ExpertiseForm from 'containers/common/LegalProceedings/JudgementAdd/Forms/JudgementAddPrononcings/ExpertiseForm';
import { VictimType } from 'typings/globalTypes';

export interface ExpertiseAddFormProps {
  intl: IntlShape;
  listings: Listings;
  victims: VictimType[];
  vehicules: Vehicule[];
  expertise: ExpertiseState;
  handleSetExpertise: Function;
  index: number;
  deleteExpertise: Function;
  setExpertiseDate?: any;
  expertiseDate?: any;
  judgementAddPronouncing?: any;
  sagisVictimInfo: any;
  sagisOpposingParties: any;
  isBasicManagement?: boolean;
}

const ExpertiseAddForm: React.FC<ExpertiseAddFormProps> = (
  props,
): JSX.Element => {
  const [expanded, setExpanded] = useState<boolean>(true);

  const handleChangeOnExpand = (
    event: React.ChangeEvent<{}>,
    expanded: boolean,
  ) => {
    setExpanded(expanded);
  };

  const deleteExpertise = (event: { stopPropagation: Function }) => {
    event.stopPropagation();
    props.deleteExpertise();
  };

  return (
    <ExpertiseFormWrapper>
      <SahamAccordion
        title={translate(messages.expertiseTitle, props, {
          number: props.index + 1,
        })}
        deleteButtonTitle={translate(messages.deleteExpertise, props)}
        expanded={expanded}
        onChange={handleChangeOnExpand}
        accordionDetailsClassName="expertise-content-wrapper"
        deleteButtonOnClick={deleteExpertise}
      >
        <ExpertiseForm
          expertise={props.expertise}
          expertisesListing={get(props.listings, LISTINGS.EXPERTISE, [])}
          handleSetExpertise={props.handleSetExpertise}
          index={props.index}
          vehicules={props.vehicules}
          victims={props.victims}
          setExpertiseDate={props.setExpertiseDate}
          expertiseDate={props.expertiseDate}
          judgementAddPronouncing={props.judgementAddPronouncing}
          sagisVictimInfo={props.sagisVictimInfo}
          sagisOpposingParties={props.sagisOpposingParties}
          isBasicManagement={props.isBasicManagement}
        />
      </SahamAccordion>
    </ExpertiseFormWrapper>
  );
};

export default injectIntl(ExpertiseAddForm);
